/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react'
import { HospitalFormSchema, updateHospitalFormSchema } from '../../schemas/HospitalFormSchema'
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { Button, InputLabel } from '@mui/material';
import InputController from '../../components/InputController/InputController';
import { FormContainer, SubmitWrapper } from './HospitalStyle';
import useToast from '../../hooks/useToast';
import CustomToast from '../../components/Toast/CustomToast';
import useMasterApi from '../../services/useMasterApi';
import { ENDPOINT } from '../../services/endPoints';
import { useNavigate } from 'react-router-dom';
import CustomApiLoader from '../../components/CustomApiLoader/CustomApiLoader';
import { useUpdateForm } from '../../context/UpdateFormProvider';
import useUnload from '../../hooks/useUnload';
import { regions } from '../Nurses/formOptions';
import SelectController from '../../components/SelectController/SelectController';

const AddHospital = () => {
  const { toastMessage, toast, toastType, setToast, showToast } = useToast()
  // const { handleUnload, handleLoad, handleBeforeUnload } = useUnload()
  const { loading:addLoading, data: addResponse, error, post } = useMasterApi()
  const { loading:updateLoading, data: updateResponse, error:updateError, put } = useMasterApi()
  const {updateFormValues} = useUpdateForm()

  let {
    hospital_Name = "",
    hospital_address = "",
    hospital_contact = "",
    hospital_contact_person_name = "",
    hospital_email_id = "",
    hospital_region = "",
    hospital_zio_code = "",
    password = "",
  } = updateFormValues || {};

  const isUpdate = !!Object.keys(updateFormValues || {}).length


  const navigate = useNavigate()
  const { handleSubmit,  reset, control, formState: {errors, isValid, isDirty} } = useForm({
    resolver: yupResolver(isUpdate ? updateHospitalFormSchema : HospitalFormSchema ),
    mode: "onChange",
    defaultValues:{
      hospital_Name: isUpdate ? hospital_Name : "",
      hospital_email_id: isUpdate? hospital_email_id : "",
      password: isUpdate ? "**********" : "",
      confirmPassword: isUpdate ? "**********" : "",
      hospital_contact: isUpdate? hospital_contact : "",
      hospital_region: isUpdate? hospital_region : "",
      hospital_contact_person_name:  isUpdate ? hospital_contact_person_name :"",
      hospital_address: isUpdate ? hospital_address : "",
      hospital_zio_code: isUpdate? hospital_zio_code : "",
    }
  });

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      event.preventDefault();
      event.returnValue = '';
    };
  
    const handleLoad = () => {
      const navigationEntry = window.performance.getEntriesByType("navigation")[0];
      if (navigationEntry && navigationEntry.type === 'reload') {
        navigate('/hospital-list'); 
      }
    };
  
    window.addEventListener('beforeunload', handleBeforeUnload);
    window.addEventListener('load', handleLoad);
  
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener('load', handleLoad);
    };
  }, []);



  const onSubmit = async (data)=>{
    if (isUpdate) {
      const formData = { ...data };
      delete formData.confirmPassword;
        await put(`${ENDPOINT.HOSPITAL}/${updateFormValues.hospital_id}`, formData )
    } else {
      const formData = { ...data };
        delete formData.confirmPassword;
      await post(ENDPOINT.HOSPITAL, formData)
    }
    reset();
  }

  useEffect(()=>{
      if(addResponse.success){
        showToast("success", "Hospital Added Successfully")
        setTimeout(()=>navigate("/hospital-list", {replace: true}), 1500)
      } 
      if(error){
        showToast("error", error.data.error)
        setTimeout(()=>navigate("/hospital-list", {replace: true}), 1500)
      }

      if(updateResponse.success){
        showToast("success", "Hospital Updated Successfully")
        setTimeout(()=>navigate("/hospital-list", {replace: true}), 1500)
      }
      if(updateError){
        showToast("error", updateError.data.error)
        // setTimeout(()=>navigate("/hospital-list", {replace: true}), 1500)
      }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[addResponse, error, updateResponse, updateError])


  return (
    <>
    <form onSubmit={handleSubmit(onSubmit)}>
                <InputLabel sx={{fontSize: "1.5rem"}}>Add Referral Facility</InputLabel>
                <FormContainer>
                   <InputController
                     name="hospital_Name"
                     label="Name"
                     control={control}
                     isLoading={addLoading || updateLoading}
                     errors={errors}/>

                     <InputController
                     name="hospital_email_id"
                     label="Email ID"
                     control={control}
                     isLoading={addLoading || updateLoading}
                     errors={errors}/>

                     <InputController
                     name="hospital_contact"
                     label="Contact Number"
                     isNumberField={true}
                     control={control}
                     isLoading={addLoading || updateLoading}
                     errors={errors}/>
                     
                     <SelectController
          name="hospital_region"
          label="Region"
          control={control}
          options={regions}
          isLoading={addLoading || updateLoading}
          errors={errors}
         
        />

                     <InputController
                     name="hospital_contact_person_name"
                     label="Contact Person Name"
                     control={control}
                     isLoading={addLoading || updateLoading}
                     errors={errors}/>

                     <InputController
                     name="hospital_zio_code"
                     label="Zip Code"
                     control={control}
                     isLoading={addLoading || updateLoading}
                     errors={errors}/>
                     
                     <InputController
                     name="password"
                     label="Password"
                     control={control}
                     isLoading={addLoading || !!password}
                     errors={errors}
                     isGrow
                     />

          <InputController
          name="confirmPassword"
          label="Confirm Password"
          control={control}
          isLoading={addLoading || !!password}
          errors={errors} 
          isGrow
          isCustomError
          />


                     <InputController
                     name="hospital_address"
                     label="Address"
                     control={control}
                     isLoading={addLoading || updateLoading}
                     errors={errors}
                     isGrow
                     />
                     
             </FormContainer>
            <SubmitWrapper>
                <Button type="submit" variant="contained"
                  sx={{minWidth:"180px"}}
                  disabled={!isValid || (addLoading || updateLoading)}>{addLoading || updateLoading ? <CustomApiLoader/> : isUpdate ? "Update" : "Add" }</Button>
                   <Button type="button" variant="contained" onClick={()=>reset()}
                   sx={{minWidth:"180px"}} disabled={addLoading || updateLoading || isUpdate}>Reset</Button>
            </SubmitWrapper>
    </form> 

     {toast && <CustomToast 
        open={toast}
        toastMessage={toastMessage}
        setToast={setToast}
        toastType={toastType}
      />}

    </>
  )
}

export default AddHospital